import { render } from "./ApproveLeaveRequestModal.vue?vue&type=template&id=a8dcd748"
import script from "./ApproveLeaveRequestModal.vue?vue&type=script&lang=js"
export * from "./ApproveLeaveRequestModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__